import { Injectable } from '@angular/core';

import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';

@Injectable()
export class BarDateTimeIntl extends OwlDateTimeIntl {
    /** A label for the up second button (used by screen readers).  */
    upSecondLabel = 'Seconde verhogen';
    /** A label for the down second button (used by screen readers).  */
    downSecondLabel = 'Seconde verlagen';
    /** A label for the up minute button (used by screen readers).  */
    upMinuteLabel = 'Minuut verhogen';
    /** A label for the down minute button (used by screen readers).  */
    downMinuteLabel = 'Minuut verlagen';
    /** A label for the up hour button (used by screen readers).  */
    upHourLabel = 'Uur verhogen';
    /** A label for the down hour button (used by screen readers).  */
    downHourLabel = 'Uur verlagen';
    /** A label for the previous month button (used by screen readers). */
    prevMonthLabel = 'Vorige maand';
    /** A label for the next month button (used by screen readers). */
    nextMonthLabel = 'Volgende maand';
    /** A label for the previous year button (used by screen readers). */
    prevYearLabel = 'Vorig jaar';
    /** A label for the next year button (used by screen readers). */
    nextYearLabel = 'Volgend jaar';
    /** A label for the previous multi-year button (used by screen readers). */
    prevMultiYearLabel = 'Vorige 21 jaren';
    /** A label for the next multi-year button (used by screen readers). */
    nextMultiYearLabel = 'Volgende 21 jaren';
    /** A label for the 'switch to month view' button (used by screen readers). */
    switchToMonthViewLabel = 'Verwisselen van jaar naar maand';
    /** A label for the 'switch to year view' button (used by screen readers). */
    switchToMultiYearViewLabel = 'Verwisselen van maand naar jaar';
    /** A label for the cancel button */
    cancelBtnLabel = 'Annuleren';
    /** A label for the set button */
    setBtnLabel = 'Instellen';
    /** A label for the range 'from' in picker info */
    rangeFromLabel = 'Van';
    /** A label for the range 'to' in picker info */
    rangeToLabel = 'Tot';
    /** A label for the hour12 button (AM) */
    hour12AMLabel = 'AM';
    /** A label for the hour12 button (PM) */
    hour12PMLabel = 'PM';
}
